import type { SkeletonTemplateEdgeT, SkeletonTemplateNodeT } from '../../labelling/types/annotations.type';
export type TemplateNodeT = Required<SkeletonTemplateNodeT>;
export type TemplateEdgeT = SkeletonTemplateEdgeT;
export type PendingNodeT = {
  id: string;
  x: number;
  y: number;
};
export type EdgePreviewT = {
  sourceNodeId: string;
  xPx: number;
  yPx: number;
};
export const UNDOABLE_EVENTS = ({
  ADD_NODE: 'ADD_NODE',
  DELETE_NODE: 'DELETE_NODE',
  ADD_EDGE: 'ADD_EDGE',
  DELETE_EDGE: 'DELETE_EDGE',
  CLEAR_CANVAS: 'CLEAR_CANVAS'
} as const);
export type AddNodePayload = {
  type: typeof UNDOABLE_EVENTS.ADD_NODE;
  node: TemplateNodeT;
};
export type DeleteNodePayload = {
  type: typeof UNDOABLE_EVENTS.DELETE_NODE;
  nodeId: string;
};
export type AddEdgePayload = {
  type: typeof UNDOABLE_EVENTS.ADD_EDGE;
  edge: TemplateEdgeT;
};
export type DeleteEdgePayload = {
  type: typeof UNDOABLE_EVENTS.DELETE_EDGE;
  sourceNodeId: string;
  targetNodeId: string;
};
export type ClearCanvasPayload = {
  type: typeof UNDOABLE_EVENTS.CLEAR_CANVAS;
};
export type UndoableEventPayloads = AddNodePayload | DeleteNodePayload | AddEdgePayload | DeleteEdgePayload | ClearCanvasPayload;
export const EVENTS = ({
  SELECT_NODE: 'SELECT_NODE',
  MOVE_NODE: 'MOVE_NODE',
  CHANGE_NODE_COLOR: 'CHANGE_NODE_COLOR'
} as const);
export type SelectNodePayload = {
  type: typeof EVENTS.SELECT_NODE;
  nodeId: string | null;
};
export type MoveNodePayload = {
  type: typeof EVENTS.MOVE_NODE;
  nodeId: string;
  x: number;
  y: number;
};
export type ChangeNodeColorPayload = {
  type: typeof EVENTS.CHANGE_NODE_COLOR;
  nodeId: string;
  color: string;
};
export type TemplateEvent = UndoableEventPayloads | SelectNodePayload | MoveNodePayload | ChangeNodeColorPayload;